import { useContext } from "react"
import { ConfigContext } from "../../Context/ConfigContext"
import { NavLink, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./Makes.css";

const Makes = () => {

  const { t } = useTranslation();
  const navigate = useNavigate();
  const { saveCarInformation, makes } = useContext(ConfigContext);
  const dir = localStorage.getItem("dir");

  const removeCar = (MFA_BRAND) => {
    saveCarInformation('', '', '', '', '');
    localStorage.setItem('pc_id', '');
    localStorage.setItem('ms_id', '');
    localStorage.setItem('car_info', '');
    navigate(`/Car-Brands/${MFA_BRAND}`);
    window.scrollTo(0, 0);
  }

  return (
    <center>
      <div className="container custom-make-container">
        <h2 style={{ lineHeight: '0' }}>{t('popular_vehicle_makes')}</h2>

        <div className="row justify-content-center mt-2 make-row">
          {
            makes.map((make) => {
              if ([80, 111, 5, 121, 16, 39, 819, 1526, 138, 184, 183, 842, 45, 36, 1820, 77].includes(make.MFA_ID)) {
                return (
                  <div
                    onClick={() => { removeCar(make.MFA_BRAND); }}
                    style={{ cursor: 'pointer' }}
                    className='make-card-wrapper'
                    key={make.MFA_ID}
                  >
                    <div
                      className="make-card"
                      style={{
                        width: '140px',
                        height: '70px',
                        backgroundColor: '#FFF',
                        textAlign: 'center',
                        marginLeft: '10px',
                        marginTop: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: '1px solid #CCC',
                        borderRadius: '5px'
                      }}
                    >
                      <NavLink className={`nav-link-custom`}>
                        {make.MFA_BRAND}
                      </NavLink>
                    </div>
                  </div>
                )
              }
              return null;
            })
          }
        </div>

        <br />

        <center style={{ direction: dir === 'rtl' ? 'ltr' : '' }}>
          <NavLink className={`mt-4`} to={`/Car-Brands`}>
            {t('all_vehicle_makes')} <i className="fas fa-chevron-right"></i>
          </NavLink>
        </center>

        <br />
        <br />
      </div>
    </center>
  )
}

export default Makes;
